import styled from 'styled-components';
import {
  PADDING,
  MARGIN,
  REBRAND_COLOR,
  BREAKPOINT
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const MainWrapper = styled.div`
  background-color: ${({ background }) =>
    background ? background : REBRAND_COLOR.MID_BLUE_10};
  padding: ${PADDING.P64} 0;
`;

export const Wrapper = styled(Section)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 32px;
  @media (min-width: ${BREAKPOINT.LG}) {
    flex-direction: row;
  }
`;

export const ImageSection = styled.div`
  width: 100%;
  height: auto;
  @media (min-width: ${BREAKPOINT.LG}) {
    width: 300px;
    height: auto;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 15px;
  object-fit: cover;
  display: block;
`;

export const SectionContainer = styled.div`
  flex: 1;
`;

export const ItemBlock = styled.div`
  margin-top: ${MARGIN.M32};
  @media (min-width: ${BREAKPOINT.LG}) {
    margin-top: ${MARGIN.M16};
  }
`;

export const MobileTitleSection = styled.div`
  display: block;
  @media (min-width: ${BREAKPOINT.LG}) {
    display: none;
  }
`;

export const DesktopTitleSection = styled.div`
  display: none;
  @media (min-width: ${BREAKPOINT.LG}) {
    display: block;
  }
`;